import { getAllWorkSheets, activeSheetProps } from "./officedocumenthelper";
import { WorkbookSettings } from "../types/app.storage.enums";
import { getObjectFromWorkbookStorage, setObjectToWorkbookStorage } from "./officestoragehelper";

export const initializeSheetOptions = async () => {
  const sheets = await getAllWorkSheets();
  let sheetOption = await getObjectFromWorkbookStorage(WorkbookSettings.SheetOptions);
  if (sheetOption.length == 0) {
    const value = sheets.map((item) => {
      return {
        sheetId: item.id,
        sheetName: item.name,
        performHoldingLookThrough: false,
        CurrencyHedgeFlag: false,
        CurrencyHedgesetId: 0,
        useReceivedDateFitler: false,
        excludeFrozenAssets: true,
      };
    });
    setObjectToWorkbookStorage(WorkbookSettings.SheetOptions, value);
  } else {
    sheets.forEach((item) => {
      if (!sheetOption.find((x) => x.sheetId === item.id))
        sheetOption.push({
          sheetId: item.id,
          sheetName: item.name,
          performHoldingLookThrough: false,
          CurrencyHedgeFlag: false,
          CurrencyHedgesetId: 0,
          useReceivedDateFitler: false,
          excludeFrozenAssets: true,
        });
    });
    const toDelete = sheetOption.filter((item) => !sheets.some((elem) => elem.id === item.sheetId));
    sheetOption = sheetOption.filter((item) => !toDelete.some((elem) => elem.id === item.sheetId));
    setObjectToWorkbookStorage(WorkbookSettings.SheetOptions, sheetOption);
  }
};

export const initializeSheetState = async () => {
  const sheets = await getAllWorkSheets();
  let sheetOption = await getObjectFromWorkbookStorage(WorkbookSettings.SheetState);
  if (sheetOption.length == 0) {
    const value = sheets.map((item) => {
      return {
        sheetId: item.id,
        sheetName: item.name,
        sheetState: true,
        BatchCount: 0,
        CompletedBatchCount: 0,
      };
    });
    setObjectToWorkbookStorage(WorkbookSettings.SheetState, value);
  } else {
    sheets.forEach((item) => {
      if (!sheetOption.find((x) => x.sheetId === item.id))
        sheetOption.push({
          sheetId: item.id,
          sheetName: item.name,
          sheetState: true,
          BatchCount: 0,
          CompletedBatchCount: 0,
        });
    });
    const toDelete = sheetOption.filter((item) => !sheets.some((elem) => elem.id === item.sheetId));
    sheetOption = sheetOption.filter((item) => !toDelete.some((elem) => elem.id === item.sheetId));
    setObjectToWorkbookStorage(WorkbookSettings.SheetState, sheetOption);
  }
};
export const getActiveSheetOptions = async () => {
  let options;
  const sheetProps = await activeSheetProps();
  const sheetOption = await getObjectFromWorkbookStorage(WorkbookSettings.SheetOptions);
  if (sheetOption.length > 0) options = sheetOption.find((item) => item.sheetId === sheetProps.id);
  return options;
};

export const setActiveSheetOptions = async (option) => {
  const sheetOption = await getObjectFromWorkbookStorage(WorkbookSettings.SheetOptions);
  const index = sheetOption.findIndex((obj) => obj.sheetId === option.sheetId);
  if (index === -1) sheetOption.push(option);
  else {
    sheetOption[index].performHoldingLookThrough = option.performHoldingLookThrough;
    sheetOption[index].CurrencyHedgeFlag = option.CurrencyHedgeFlag;
    sheetOption[index].CurrencyHedgesetId = option.CurrencyHedgesetId;
    sheetOption[index].useReceivedDateFitler = option.useReceivedDateFitler;
    sheetOption[index].excludeFrozenAssets = option.excludeFrozenAssets;
  }
  setObjectToWorkbookStorage(WorkbookSettings.SheetOptions, sheetOption);
};

export const setActiveSheetState = async (option) => {
  const sheetOption = await getObjectFromWorkbookStorage(WorkbookSettings.SheetState);
  const index = sheetOption.findIndex((obj) => obj.sheetId === option.sheetId);
  if (index === -1) sheetOption.push(option);
  else {
    sheetOption[index].sheetState = option.sheetState;
    sheetOption[index].CompletedBatchCount = option.CompletedBatchCount;
    sheetOption[index].BatchCount = option.BatchCount;
  }
  setObjectToWorkbookStorage(WorkbookSettings.SheetState, sheetOption);
};

export const getActiveSheetState = async () => {
  let options;
  const sheetProps = await activeSheetProps();
  const sheetOption = await getObjectFromWorkbookStorage(WorkbookSettings.SheetState);
  if (sheetOption.length > 0) options = sheetOption.find((item) => item.sheetId === sheetProps.id);
  return options;
};
export const getActiveSheetStatebyId = async (id) => {
  let options;
  const sheetOption = await getObjectFromWorkbookStorage(WorkbookSettings.SheetState);
  if (sheetOption.length > 0) options = sheetOption.find((item) => item.sheetId === id);
  return options;
};
